import React, { useState, useEffect } from 'react';

import { Fade, Button } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';

import MultiSelectModal from '../../modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal';

export default ({
    opcoesFiltroPedidos,
    opcoesFiltroPedidosValue,
    label,
    btlabel,
    handlerFiltroPedidos,
}) => {
    const [radioValue, setRadioValue] = useState(opcoesFiltroPedidosValue);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [itensModal, setItensModal] = useState(opcoesFiltroPedidos);

    const headerModal = { title: label };
    const btComponent = { label: btlabel };
    const buttonType = 'radio';

    const handleDialogModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const setIdOnChange = (idButtonChecked, checked) => {
        setRadioValue(idButtonChecked);
    };

    const getIdOnClick = () => {
        handleDialogModal();
        handlerFiltroPedidos(radioValue);
    };

    useEffect(() => {
        setRadioValue(opcoesFiltroPedidosValue)
    }, [opcoesFiltroPedidosValue])

    return (
        <>
            <Button
                variant='contained'
                onClick={handleDialogModal}
                endIcon={<ArrowDropDown />}
                style={{ borderRadius: '20px' }}
            >
                Filtrar pedidos por status
            </Button>

            <Fade in={isModalOpen}>
                <MultiSelectModal
                    checkedId={radioValue}
                    isModalOpen={isModalOpen}
                    headerModal={headerModal}
                    btComponent={btComponent}
                    buttonType={buttonType}
                    itensModal={itensModal}
                    setIdOnChange={setIdOnChange}
                    getIdOnClick={getIdOnClick}
                    handleDialogModal={handleDialogModal}
                />
            </Fade>
        </>
    );
};
